import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FileMultiple = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M9.60015 5.2V7.6C9.60015 8.04183 9.95833 8.4 10.4002 8.4H12.8002M14.4002 2H8.79997C7.91631 2 7.19997 2.71634 7.19997 3.59999V5.2M14.4002 2H14.8464C15.0717 2 15.2862 2.09489 15.4414 2.25819C15.6746 2.50359 16.0441 2.88143 16.4002 3.2C16.6792 3.44968 17.1176 3.89776 17.3801 4.17009C17.5221 4.31736 17.6002 4.514 17.6001 4.71856L17.6001 5.2M14.4002 2V4.4C14.4002 4.84183 14.7583 5.2 15.2002 5.2H17.6001M17.6001 5.2L17.5999 13.2C17.5999 14.0837 16.8836 14.8 15.9999 14.8H12.7999M11.6002 6.4C11.2441 6.08143 10.8746 5.70359 10.6414 5.45819C10.4862 5.29489 10.2717 5.2 10.0464 5.2H3.99996C3.11631 5.2 2.39997 5.91634 2.39996 6.79999L2.3999 16.4C2.3999 17.2836 3.11624 18 3.9999 18L11.1999 18C12.0836 18 12.7999 17.2837 12.7999 16.4L12.8001 7.91856C12.8002 7.714 12.7221 7.51736 12.5801 7.37009C12.3176 7.09777 11.8792 6.64968 11.6002 6.4Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default FileMultiple
